import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { OfflineBannerComponent } from './offline-banner/offline-banner';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
@NgModule({
	declarations:
		[OfflineBannerComponent],
	imports: [BrowserModule, FormsModule],
	exports: [OfflineBannerComponent],
	schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class ComponentsModule { }



// WEBPACK FOOTER //
// ./src/components/components.module.ts